import React from 'react';
import { View } from 'react-native';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { VXLComponent } from 'shared/renderer/types';

import ComponentRegistry from './ComponentRegistry';

export interface ComponentRendererProps {
  toRender: VXLComponent;
}

const ComponentRenderer = ({ toRender }: ComponentRendererProps) => {
  if (!toRender) {
    return null;
  }
  const Component = ComponentRegistry[toRender.name];
  if (!Component) {
    return (
      <View>
        <BodyBaseText>oops! something went wrong</BodyBaseText>
      </View>
    );
  }

  return <Component {...(toRender.props as any)} />;
};

export default ComponentRenderer;
